import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsDateString } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class WorkFlowModel {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  startId!: number;
  @IsDateString()
  @Expose()
  nextRunAt!: string;
  @IsNumber()
  @Expose()
  state!: number;
  @IsNumber()
  @Expose()
  tryCount!: number;
  @IsString()
  @Expose()
  prototypeName!: string;
  @IsString()
  @Expose()
  activeItem!: string;
  @IsString()
  @Expose()
  office!: string;
}

export class WorkFlowModelResponse extends GenericTableResponse<WorkFlowModel> {
  @Expose()
  @IsArray()
  @Type(() => WorkFlowModel)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<WorkFlowModel>;
}
